var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "service-num-wrap" }, [
    _c("ul", { staticClass: "service-num-list" }, [
      _c("li", { staticClass: "service-num-item" }, [
        _c("div", { staticClass: "goods-info" }, [
          _c("div", { staticClass: "goods-image" }, [
            _vm.shopDeviceSvcSubNo.imageUrl != null &&
            _vm.shopDeviceSvcSubNo.imageUrl != ""
              ? _c("span", [
                  _c("img", { attrs: { src: _vm.shopDeviceSvcSubNo.imageUrl } })
                ])
              : _c("span", [
                  _c("img", {
                    directives: [
                      {
                        name: "resc-url",
                        rawName: "v-resc-url",
                        value: "/image/noimg.jpg",
                        expression: "'/image/noimg.jpg'"
                      }
                    ]
                  })
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "goods-summary" }, [
            _c("p", { staticClass: "name font14" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("资产描述全称")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-gray3" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.title))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("品牌")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.brandName))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("分类")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.catName))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("系统编号")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.tmpNo))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("服务子号")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.svcSubNo || "无"))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("批次号")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.batchNo || "无"))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("资产状态")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(
                  _vm._s(_vm.deviceUseStateMap[_vm.shopDeviceSvcSubNo.useState])
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("单位")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.theUnit || "无"))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "num" }, [
              _c("span", { staticClass: "mr10" }, [_vm._v("需补码")]),
              _vm._v(" "),
              _c("span", { staticClass: "value font-red" }, [
                _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.tagMissing ? "是" : "否"))
              ])
            ]),
            _vm._v(" "),
            _vm.shopDeviceSvcSubNo.tagMissing &&
            _vm.shopDeviceSvcSubNo.tagMissCause != null
              ? _c("p", { staticClass: "num" }, [
                  _c("span", { staticClass: "mr10" }, [_vm._v("需补码原因")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value font-red" }, [
                    _vm._v(_vm._s(_vm.shopDeviceSvcSubNo.tagMissCause))
                  ])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "simple-row" }, [
          _vm.shopDeviceSvcSubNo.retailerBizUnitId ==
            _vm.scopeEntity.bizUnitId && _vm.shopDeviceSvcSubNo.leaseState == 0
            ? _c("div", { staticClass: "right" }, [
                _vm.shopDeviceSvcSubNo.useState != _vm.start
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: { click: _vm.startDevice }
                      },
                      [_c("span", [_vm._v("启用")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopDeviceSvcSubNo.useState == _vm.start
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: { click: _vm.outageDevice }
                      },
                      [_c("span", [_vm._v("停用")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopDeviceSvcSubNo.state == _vm.normalValue
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.setSate(_vm.shopDeviceSvcSubNo.id, true)
                          }
                        }
                      },
                      [_c("span", [_vm._v("故障")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopDeviceSvcSubNo.state == _vm.failedValue
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.setSate(_vm.shopDeviceSvcSubNo.id, false)
                          }
                        }
                      },
                      [_c("span", [_vm._v("取消故障")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.shopDeviceSvcSubNo.tagMissing
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.setTagMissing(_vm.shopDeviceSvcSubNo, true)
                          }
                        }
                      },
                      [_c("span", [_vm._v("需补码")])]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.shopDeviceSvcSubNo.tagMissing
                  ? _c(
                      "button",
                      {
                        staticClass: "swb-btn swb-btn-small",
                        on: {
                          click: function($event) {
                            _vm.updateTagMissing(
                              _vm.shopDeviceSvcSubNo.id,
                              false
                            )
                          }
                        }
                      },
                      [_c("span", [_vm._v("已补码")])]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6db88e84", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db88e84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceStateManagement.vue
// module id = 3166
// module chunks = 0